<ng-template #content let-modal [ngIf]="content">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>EDIT</h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="submitForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="row">
        <div class="col-12 mt-2">
          <lib-gung-text-input [gungTranslate]="'ID'" formControlName="id"></lib-gung-text-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <lib-gung-text-input [gungTranslate]="'NAME'" formControlName="name"></lib-gung-text-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <lib-gung-number-input [gungTranslate]="'ORDER'" formControlName="order"></lib-gung-number-input>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <div class="form-group">
            <label for="name" translate>ACTIVE</label>
            <input type="checkbox" formControlName="active" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close('Cance click')" translate>
        CANCEL
      </button>
      <button type="submit" class="btn btn-outline-dark" translate>SAVE</button>
    </div>
  </form>
</ng-template>
